// Run a job when the page is idle, so a slow one does not land in the frame that opens a screen.

/** A busy page still runs the job within this long. */
const IDLE_DEADLINE_MS = 500;

/** Runs `job` on an idle callback (a timeout where the browser has none); returns a cancel. */
export function whenIdle(job: () => void): () => void {
  if (typeof requestIdleCallback === 'function') {
    const id = requestIdleCallback(job, { timeout: IDLE_DEADLINE_MS });
    return () => cancelIdleCallback(id);
  }

  const id = setTimeout(job, 0);
  return () => clearTimeout(id);
}
